import React from 'react'
import { storiesOf } from '@storybook/react'

import './TypographyStories'
import './GridStories'
import './ColorStories'
import './PaperStories'
import './ButtonStories'

storiesOf('Essentials', module)
  .add('Read me', () => <div>Start with getting to know these basic components before writing any code.</div>)
